import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "MailListItemExpansion", webpackPrefetch: true */ './lazyIndex');
});
// Delayed Loaded Components
export var MailListItemExpansion = createLazyComponent(lazyModule, function (m) { return m.MailListItemExpansion; });
export var FolderTag = createLazyComponent(lazyModule, function (m) { return m.FolderTag; });
//# sourceMappingURL=index.js.map